import { axiosClient } from 'www/utils'
import type { ApiSearchParamsPost, ApiSearchResponsePost } from 'www/vue_components/common/SearchBar/api/apiSearch.types'

export default {
  post(params: ApiSearchParamsPost) {
    return axiosClient.post<ApiSearchResponsePost>('/api/search/', params)
  },
}
